import './ListPaginationView.scss'

import React from "react";

import {Pagination, List, Header, Grid} from 'semantic-ui-react'

class ListPagination extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      activePage: 1
    };
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

  componentWillReceiveProps(nextProps){
    const {searchTerm, items} = this.props;

    if(nextProps.searchTerm !== searchTerm){
      this.setState({activePage: 1})
    }

    if(nextProps.items && items && nextProps.items.length !== items.length){
      this.setState({activePage: 1})
    }
  }

  render(){
    const {items, totalPages, itemsPerPage, noItemsMessage, showPagination, listStyles, horizontal, columns} = this.props;
    const {activePage} = this.state;

    if(!(items && items.length)){
      return <Header as='h4'>{noItemsMessage}</Header>
    }

    return (
      <div>
        <Grid divided='vertically'>
          <Grid.Row columns={columns}>
            {
              _.map(_.chunk(items.slice((itemsPerPage * (activePage - 1)), itemsPerPage * activePage), itemsPerPage / columns), (values, key) => {
              return (
                <Grid.Column key={key}>
                  <List horizontal={horizontal} style={listStyles} celled>
                    {_.map(values, (item, key) => item)}
                  </List>
                </Grid.Column>
              )
            })}
          </Grid.Row>
        </Grid>


        {showPagination ?
          <Pagination
            activePage={activePage}
            onPageChange={this.handlePaginationChange}
            firstItem={null}
            lastItem={null}
            pointing
            secondary
            className='center-pagination'
            totalPages={totalPages}
          />
          : null}
      </div>

    )
  }
}

export default ListPagination


// WEBPACK FOOTER //
// ./src/components/shared/ListPagination/components/ListPaginationView.js